'use client';

import { useOpen } from '@/hooks/use-open';
import classNames from 'classnames';
import { useEffect } from 'react';
import { BurgerMenuContent } from './burger-menu-content';
import { IBurgeMenu } from './burger-menu.types';

export const BurgerMenu: IBurgeMenu = ({ socialLinks }) => {
  const { open, opened, close } = useOpen();

  const toggle = () => (opened ? close() : open());

  useEffect(() => {
    if (opened) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }
  }, [opened]);

  return (
    <>
      <div
        className="md:hidden absolute top-[16px] right-[20px] z-1 w-[24px] flex flex-col gap-[5px] cursor-pointer"
        onClick={toggle}
      >
        <div
          className={classNames(
            'w-full h-[2px] bg-white ease-in rotate-0 translate-y-0 duration-200',
            {
              ['rotate-[45deg]']: opened,
              ['translate-y-[5px]']: opened,
            }
          )}
        />
        <div
          className={classNames(
            'w-full h-[2px] bg-white ease-in transition-all-200',
            {
              ['opacity-0']: opened,
              ['opacity-100']: !opened,
            }
          )}
        />
        <div
          className={classNames(
            'w-full h-[2px] ease-in bg-white rotate-0 translate-y-0 duration-200',
            {
              ['rotate-[-45deg]']: opened,
              ['translate-y-[-10px]']: opened,
            }
          )}
        />
      </div>
      <BurgerMenuContent
        visible={opened}
        socialLinks={socialLinks}
        close={close}
      />
    </>
  );
};
